<template>
  <bp-gnb
    v-if="isLoadedUserData"
    :env="profile"
    service-id="Service Portal"
    service-name="Customer Portal"
    left-menu-path="/menu-data/left-menu.json"
    hide-companies
    :my-info-url="myInfoUrl"
    :role="userInfo.auth">
    <template #logo>
      <a href="#" class="logo-header -ml-5" @click="onClickLogo">OpsNow</a>
    </template>
    <template v-if="Object.keys(userInfo).length > 0">
      <router-view />
    </template>
    <g-popup-anchor />
    <g-spinner v-if="isShowSpinner" />
    <g-toast :visible.sync="visibleToast">{{toastMessage}}</g-toast>
  </bp-gnb>
</template>

<script>
import BpGnb from 'ops2clientgnb'
import APICaller, { APIEventName } from './library/APICaller'
import { mapActions, mapGetters } from 'vuex'


import GSpinner from '@/pages/components/GSpinner'
import CodeGroupId from './code/CodeGroupId'
import CodeEventBus from './code/CodeEventBus'
import UrlsConfig from './config/urls.conf'
import UserLogoutForce from './pages/user/components/UserLogoutForce'

export default {
  components: {
    BpGnb,
    GSpinner
  },
  data () {
    return {
      visibleToast: false,
      toastMessage: null,
      isShowSpinner: false,
      isLogoutForced: false,
      isLoadedUserData: false
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    profile () {
      return UrlsConfig.profile
    },
    myInfoUrl (){
      return UrlsConfig.myInfoUrl
    }
  },
  methods: {
    ...mapActions('bills', ['getBills']),
    ...mapActions('user', ['getUserInfo']),
    ...mapActions('customer', ['getCustomersGroups']),
    ...mapActions('code', ['getCommonCodeGroups', 'getCommonCodeGroupDetail']),
    getAPIException (e) {
      if (!this.visibleToast) {
        if (e && e.response && e.response.data && e.response.data.codeName) {
          try {
            this.toastMessage = `[ ${e.response.data.codeName} (${e.response.data.code}) ] - ${e.response.data.desc}`
          } catch (e) {}
        } else {
          this.toastMessage = `[ ${e.response.status}) ] - ${e.response.statusText}`
        }
      }
    },
    getLoginStatusException(e){
      if(!this.isLogoutForced){
        this.isLogoutForced = true
        this.$popupManager.open(UserLogoutForce)
      }

    },
    showToast (e) {
      this.toastMessage = e.toastMessage
    },
    showSpinner (e) {
      this.isShowSpinner = e.showSpinner
    },
    onClickLogo (e) {
      e.preventDefault()
      this.$router.push('/home').catch(e => {})
    },
    onChangeCompany (companyId) {
      console.log(companyId)
    }
  },
  watch: {
    toastMessage (value, oldValue) {
      if (value !== oldValue) {
        if (value && value !== '') {
          this.visibleToast = true
        }
      }
    },
    visibleToast (value) {
      if (!value) {
        this.toastMessage = ''
      }
    }
  },
  async beforeMount () {
    var resultCode =  await this.getUserInfo()
    if(resultCode == 9406) {
      alert('고객 포탈 접근할 권한이 없습니다. 확인을 누르시면, 포털게이트로 이동합니다.');
      location.replace(window.urlsConfig.portalgate_url);
    }
    this.isLoadedUserData = true
    this.getCustomersGroups()
    this.getCommonCodeGroups()
    this.getCommonCodeGroupDetail({
      codeGroupId: CodeGroupId.USERGROUP
    })
    await this.getCommonCodeGroupDetail({
      codeGroupId: CodeGroupId.MIDDLE_MANAGER
    })
    await this.getCommonCodeGroupDetail({
      codeGroupId: CodeGroupId.SNS
    })
  },
  mounted () {
    this.$eventBus.$on(CodeEventBus.SHOW_TOAST, this.showToast)
    this.$eventBus.$on(CodeEventBus.SHOW_SPINNER, this.showSpinner)
    APICaller.interceptors.addListener(APIEventName.responseException, this.getAPIException)
    APICaller.interceptors.addListener(APIEventName.loginStatusException, this.getLoginStatusException)
  },
  beforeDestroy () {
    this.$eventBus.$off(CodeEventBus.SHOW_TOAST, this.showToast)
    this.$eventBus.$off(CodeEventBus.SHOW_SPINNER, this.showSpinner)
  }
}
</script>
<style>
.-toast-popup {
  z-index: 30;
}
</style>

<style src="ops2clientlibrary/src/assets/lib/notosanskr.css"></style>
<style src="ops2clientlibrary/src/assets/lib/montserrat.css"></style>
<style src="ops2clientlibrary/src/assets/styles/ui_pack_vue.css"></style>

<style src="ops2clientlibrary/src/assets/styles/custom.css"></style>
<style src="ops2clientlibrary/src/assets/styles/custom_icon.css"></style>
<style src="ops2clientlibrary/src/assets/styles/custom_container.css"></style>
<style src="ops2clientlibrary/src/assets/styles/custom_dropdown.css"></style>
<style src="ops2clientlibrary/src/assets/styles/custom_tooltip.css"></style>

<style src="ops2clientgnb/src/assets/styles/custom_gnb.css"></style>
<style src="ops2clientgnb/src/assets/styles/custom_gnb_icon.css"></style>


<style src="ag-grid-community/dist/styles/ag-grid.css"></style>
<style src="ag-grid-community/dist/styles/ag-theme-balham.css"></style>
<style src="./assets/styles/custom_ag-grid.css"></style>
<style src="./assets/styles/amchart-custom.css"></style>
<style src="./assets/styles/custom.css"></style>



// WEBPACK FOOTER //
// src/App.vue